<div class="profile-component">
    <!-- Profile Form Label -->
    <div class="profile-form-label">
        <p class="p1">{{finalResources.formLabel}}</p>
        <p class="p2">{{finalResources.formLabelDescription}}</p>
    </div>

    <!-- Main Profile Form -->
    <form [formGroup]="profileForm" (ngSubmit)="onSave()" class="profile-form">
        <div class="top-container">
            <div class="profile-section-top">
                <div class="profile-text">
                    <p class="p1">{{finalResources.profileText}}</p>
                    <p class="p2">{{finalResources.profileTextDescription}}</p>
                </div>
                <div class="profile-actions">
                    <!-- Edit Button -->
                    <button type="button" class="btn btn-sm action-btn" (click)="toggleEdit()">
                        <i *ngIf="!isEditing()" class="bi bi-pencil"></i> {{ isEditing() ? 'Cancel' : 'Edit' }}
                    </button>
                    <!-- Delete Button -->
                    <button type="button" class="btn btn-sm action-btn" (click)="deleteAccount()">
                        <i class="bi bi-trash"></i> Delete
                    </button>
                </div>
            </div>

            <div class="row mb-2">
                <div class="profile-upload-container">
                    <!-- Profile Image -->
                    <div class="profile-image-wrapper">
                        <img [src]="viewImageUrl ? viewImageUrl : (userInfo?.PictureUrl ? userInfo!.PictureUrl : 'assets/images/default-profile.png')"
                            alt="Profile" class="profile-image" (error)="onImageError($event)" />

                        <!-- Edit Icon -->
                        <div *ngIf="isEditing()" class="edit-icon">
                            <i class="bi bi-camera"></i>
                        </div>
                        <input type="file" #fileInput class="d-none" (change)="onFileSelected($event)"
                            accept="image/jpeg,image/png" />
                    </div>

                    <!-- Drag & Drop Upload -->
                    <div *ngIf="isEditing()" class="upload-box" (dragover)="onDragOver($event)"
                        (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                        <i class="bi bi-upload"></i>
                        <p>Drag and drop your profile picture here, or <a href="#"
                                (click)="fileInput.click(); $event.preventDefault()">browse</a></p>
                        <small>PNG or JPG upto 10MB</small>
                    </div>
                </div>
            </div>
        </div>


        <div #formContainer class="main-container">
            <div class="row mb-3">
                <!-- Full Name -->
                <div class="col-md-6">
                    <label for="fullName" class="form-label">
                        {{ finalResources.fullNameLabel }} <span *ngIf="isEditing()" class="text-danger">*</span>
                    </label>
                    <div *ngIf="!isEditing(); else editableFullName" class="form-value">
                        {{ profileForm.value.fullName || '-' }}
                    </div>
                    <ng-template #editableFullName>
                        <input id="fullName" formControlName="fullName" type="text" class="form-control"
                            [placeholder]="finalResources.fullNamePlaceHolder"
                            [ngClass]="{'is-invalid': profileForm.get('fullName')?.invalid && profileForm.get('fullName')?.touched}"
                            (input)="triggerValidation('fullName')" />
                    </ng-template>
                    <div *ngIf="profileForm.get('fullName')?.touched && profileForm.get('fullName')?.invalid">
                        <small class="text-danger">{{ getFullNameErrorMessage() }}</small>
                    </div>
                </div>

                <!-- Date of Birth -->
                <div class="col-md-6">
                    <label for="dob" class="form-label">
                        {{ finalResources.dobLabel }}
                    </label>

                    <div *ngIf="!isEditing(); else editableDob" class="form-value">
                        {{ profileForm.value.dob ? (profileForm.value.dob | date: 'dd-MMM-yyyy') : '-' }}
                    </div>

                    <ng-template #editableDob>
                        <input #dobInput id="dob" formControlName="dob" type="date" class="form-control" [max]="maxDate"
                            [ngClass]="{'is-invalid': profileForm.get('dob')?.touched && (profileForm.get('dob')?.invalid || dobInput.validity.badInput)}"
                            (keydown)="onDobChange()" />
                        <div class="invalid-feedback d-block"
                            *ngIf="profileForm.get('dob')?.touched && (profileForm.get('dob')?.invalid || dobInput.validity.badInput)">
                            <small class="text-danger">
                                <span *ngIf="dobInput.validity.badInput">{{ finalResources.invalidDateErrMsg }}</span>
                                <span *ngIf="!dobInput.validity.badInput">{{ getDobErrorMessage() }}</span>
                            </small>
                        </div>
                    </ng-template>


                </div>
            </div>

            <div class="row mb-3">
                <!-- Mobile -->
                <div class="col-md-6">
                    <label for="mobile" class="form-label d-flex align-items-center gap-1">
                        {{ finalResources.mobileNumberLabel }}
                        <mat-icon aria-hidden="false" *ngIf="isEditing() && !allowMobileOtp" fontIcon="info"
                            title="Mobile updating is restricted in your region"></mat-icon>
                    </label>

                    <div *ngIf="!isEditing(); else editableMobile" class="form-value">
                        {{ userInfo?.Mobile || '-'}}
                    </div>
                    <ng-template #editableMobile>
                        <input id="mobile" formControlName="mobile" type="text" tabindex="-1" class="form-control"
                            [placeholder]="finalResources.mobileNumberPlaceHolder" (input)="triggerValidation('mobile')"
                            [ngClass]="{'is-invalid': profileForm.get('mobile')?.invalid && profileForm.get('mobile')?.touched,
                            'form-control-disabled': !allowMobileOtp}" />
                    </ng-template>
                    <!-- Validation Messages -->
                    <div *ngIf="profileForm.get('mobile')?.touched && profileForm.get('mobile')?.invalid">
                        <small class="text-danger">
                            {{ getMobileErrorMessage() }}
                        </small>
                    </div>
                </div>

                <!-- Gender -->
                <div class="col-md-6">
                    <label for="gender" class="form-label">
                        {{ finalResources.genderLabel }}
                    </label>
                    <div *ngIf="!isEditing(); else editableGender" class="form-value">
                        {{ getGenderLabel(profileForm.value.gender) }}
                    </div>
                    <ng-template #editableGender>
                        <select id="gender" formControlName="gender" class="form-control"
                            [ngClass]="{'is-invalid': profileForm.get('gender')?.invalid && profileForm.get('gender')?.touched}">
                            <option value="" disabled selected>{{finalResources.genderPlaceHolder}}</option>
                            <option *ngFor="let lang of genderOptions" [value]="lang.textValue">
                                {{ lang.value }}
                            </option>
                        </select>
                    </ng-template>
                </div>

            </div>

            <div class="row mb-3">
                <!-- Mother Tongue -->
                <div class="col-md-6">
                    <label for="motherTongue" class="form-label">
                        {{ finalResources.motherTongueLabel }}
                    </label>
                    <div *ngIf="!isEditing(); else editableMotherTongue" class="form-value">
                        {{ profileForm.value.motherTongue || '-' }}
                    </div>
                    <ng-template #editableMotherTongue>
                        <select id="motherTongue" formControlName="motherTongue" class="form-control"
                            [ngClass]="{'is-invalid': profileForm.get('motherTongue')?.invalid && profileForm.get('motherTongue')?.touched}">
                            <option value="" disabled selected>{{finalResources.motherTonguePlaceHolder}}</option>
                            <option *ngFor="let lang of motherTongueOptions" [value]="lang.name">
                                {{ lang.name }}
                            </option>
                        </select>
                    </ng-template>
                </div>

                <!-- Email -->
                <div class="col-md-6">
                    <label for="email" class="form-label d-flex align-items-center gap-1">
                        {{ finalResources.emailAddressLabel }} <span *ngIf="isEditing()" class="text-danger">*</span>
                        <mat-icon aria-hidden="false" *ngIf="isEditing() && !allowEmailOtp" fontIcon="info"
                            title="Email updating is restricted in your region"></mat-icon>
                    </label>
                    <div *ngIf="!isEditing(); else editableEmail" class="form-value">
                        {{ userInfo?.Email || '-' }}
                    </div>
                    <ng-template #editableEmail>
                        <input id="email" formControlName="email" type="email" tabindex="-1" class="form-control"
                            [placeholder]="finalResources.emailAddressPlaceHolder" (input)="triggerValidation('email')"
                            [ngClass]="{'is-invalid': profileForm.get('email')?.invalid && profileForm.get('email')?.touched,
                            'form-control-disabled': !allowEmailOtp}" />
                    </ng-template>
                    <div *ngIf="profileForm.get('email')?.touched && profileForm.get('email')?.invalid">
                        <small class="text-danger" *ngIf="profileForm.get('email')?.errors">
                            {{ getEmailErrorMessage() }}
                        </small>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <!-- Preferred Language -->
                <div class="col-md-6">
                    <label for="preferredLanguage" class="form-label">
                        {{ finalResources.preferredLanguageLabel }}
                    </label>
                    <div *ngIf="!isEditing(); else editablePreferredLanguage" class="form-value">
                        {{ profileForm.value.preferredLanguage || '-' }}
                    </div>
                    <ng-template #editablePreferredLanguage>
                        <select id="preferredLanguage" formControlName="preferredLanguage" class="form-control"
                            [ngClass]="{'is-invalid': profileForm.get('preferredLanguage')?.invalid
                            && profileForm.get('preferredLanguage')?.touched}">
                            <option *ngFor="let lang of preferredLanguagesOptions" [value]="lang.code">
                                {{ lang.name }}
                            </option>
                        </select>
                    </ng-template>
                </div>
            </div>

            <!-- Address -->
            <div class="row mb-2">
                <div class="col-md-12">
                    <label *ngIf="!isEditing()" class="form-label address-label">{{ finalResources.addressLabel
                        }}</label>
                    <div class="mb-3 address-toggle" *ngIf="isEditing()">
                        <mat-slide-toggle class="form-label custom-toggle" [(ngModel)]="provideAddress"
                            [ngModelOptions]="{standalone: true}" (change)="onProvideAddressToggle($event.checked)">
                            {{finalResources.addressLabel}}
                        </mat-slide-toggle>
                    </div>
                    <div formGroupName="primaryAddress">
                        <!-- Line 1 -->
                        <div class="mb-3">
                            <label for="primaryAddress-line1" class="form-label">Address Line 1 <span
                                    *ngIf="provideAddress && isEditing()" class="text-danger">*</span></label>

                            <div *ngIf="!isEditing(); else editablePrimaryAddressLine1" class="form-value">
                                {{ profileForm.get('primaryAddress.line1')?.value || '-' }}
                            </div>
                            <ng-template #editablePrimaryAddressLine1>
                                <input type="text" class="form-control" id="primaryAddress-line1"
                                    formControlName="line1" [disabled]="!isEditing() || !provideAddress"
                                    [ngClass]="{'is-invalid': profileForm.get('primaryAddress.line1')?.invalid &&
                                    (profileForm.get('primaryAddress.line1')?.touched || profileForm.get('primaryAddress.line1')?.dirty),'form-control-disabled': !provideAddress}">
                            </ng-template>
                            <div
                                *ngIf="isEditing() && profileForm.get('primaryAddress.line1')?.invalid &&
                                    (profileForm.get('primaryAddress.line1')?.touched || profileForm.get('primaryAddress.line1')?.dirty)">
                                <ng-container *ngIf="profileForm.get('primaryAddress.line1')?.errors as errors">
                                    <small class="text-danger" *ngIf="errors['required']">Address Line 1 is
                                        required.</small>
                                    <small class="text-danger" *ngIf="!errors['required'] && errors['onlySpaces']">
                                        Address Line 1 cannot contain only spaces.</small>
                                    <small class="text-danger" *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                            errors['maxlength']">Address Line 1 must be 200 characters or less.</small>
                                    <small class="text-danger" *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                        !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                        Address Line 1 (excluding spaces) must be 200 characters or less.</small>
                                    <small class="text-danger"
                                        *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                        !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['invalidPattern']">
                                        Address Line 1 contains invalid characters (only letters, numbers, spaces, and -
                                        , . / ( ) & # are allowed).</small>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Line 2 -->
                        <div class="mb-3">
                            <label for="primaryAddress-line2" class="form-label">Address Line 2</label>
                            <div *ngIf="!isEditing(); else editablePrimaryAddressLine2" class="form-value">
                                {{ profileForm.get('primaryAddress.line2')?.value || '-' }}
                            </div>
                            <ng-template #editablePrimaryAddressLine2>
                                <input type="text" class="form-control" id="primaryAddress-line2"
                                    formControlName="line2" [disabled]="!isEditing() || !provideAddress"
                                    [ngClass]="{'is-invalid': profileForm.get('primaryAddress.line2')?.invalid &&
                                    (profileForm.get('primaryAddress.line2')?.touched || profileForm.get('primaryAddress.line2')?.dirty), 'form-control-disabled': !provideAddress}">
                            </ng-template>
                            <div
                                *ngIf="isEditing() && profileForm.get('primaryAddress.line2')?.invalid &&
                                        (profileForm.get('primaryAddress.line2')?.touched || profileForm.get('primaryAddress.line2')?.dirty)">
                                <ng-container *ngIf="profileForm.get('primaryAddress.line2')?.errors as errors">
                                    <small class="text-danger" *ngIf="errors['onlySpaces']">Address Line 2 cannot
                                        contain only spaces.</small>
                                    <small class="text-danger" *ngIf="!errors['onlySpaces'] && errors['maxlength']">
                                        Address Line 2 must be 200 characters or less.</small>
                                    <small class="text-danger" *ngIf="!errors['onlySpaces'] && !errors['maxlength'] &&
                                        errors['maxlengthNoSpaces']">Address Line 2 (excluding spaces) must be 200
                                        characters or less.</small>
                                    <small class="text-danger" *ngIf="!errors['onlySpaces'] && !errors['maxlength'] &&
                                        !errors['maxlengthNoSpaces'] && errors['invalidPattern']">
                                        Address Line 2 contains invalid characters (only letters, numbers, spaces, and -
                                        , . / ( ) & # are allowed).</small>
                                </ng-container>
                            </div>
                        </div>

                        <div class="row">
                            <!-- City -->
                            <div class="col-6 mb-3">
                                <label for="primaryAddress-city" class="form-label">City <span
                                        *ngIf="provideAddress && isEditing()" class="text-danger">*</span></label>
                                <div *ngIf="!isEditing(); else editablePrimaryAddressCity" class="form-value">
                                    {{ profileForm.get('primaryAddress.city')?.value || '-' }}
                                </div>
                                <ng-template #editablePrimaryAddressCity>
                                    <input type="text" class="form-control" id="primaryAddress-city"
                                        formControlName="city" [disabled]="!isEditing() || !provideAddress"
                                        [ngClass]="{'is-invalid': profileForm.get('primaryAddress.city')?.invalid &&
                                            (profileForm.get('primaryAddress.city')?.touched || profileForm.get('primaryAddress.city')?.dirty),'form-control-disabled': !provideAddress}">
                                </ng-template>

                                <div
                                    *ngIf="isEditing() && profileForm.get('primaryAddress.city')?.invalid &&
                                         (profileForm.get('primaryAddress.city')?.touched || profileForm.get('primaryAddress.city')?.dirty)">
                                    <ng-container *ngIf="profileForm.get('primaryAddress.city')?.errors as errors">
                                        <small class="text-danger" *ngIf="errors['required']">City is required.</small>
                                        <small class="text-danger" *ngIf="!errors['required'] && errors['onlySpaces']">
                                            City cannot contain only spaces.</small>
                                        <small class="text-danger" *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                            errors['maxlength']">City must be 100 characters or less.</small>
                                        <small class="text-danger" *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                                !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                            City (excluding spaces) must be 100 characters or less.</small>
                                        <small class="text-danger"
                                            *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                                !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['pattern']">
                                            City can only contain letters, spaces, and hyphens (-).</small>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Postal Code -->
                            <div class="col-6 mb-3">
                                <label for="primaryAddress-postalCode" class="form-label">Postal Code <span
                                        *ngIf="provideAddress && isEditing()" class="text-danger">*</span></label>
                                <div *ngIf="!isEditing(); else editablePrimaryAddressPostalCode" class="form-value">
                                    {{ profileForm.get('primaryAddress.postalCode')?.value || '-' }}
                                </div>
                                <ng-template #editablePrimaryAddressPostalCode>
                                    <input type="text" class="form-control" id="primaryAddress-postalCode"
                                        placeholder="3-12 character postal code" formControlName="postalCode"
                                        [disabled]="!isEditing() || !provideAddress"
                                        [ngClass]="{'is-invalid': profileForm.get('primaryAddress.postalCode')?.invalid &&
                                        (profileForm.get('primaryAddress.postalCode')?.touched || profileForm.get('primaryAddress.postalCode')?.dirty), 'form-control-disabled': !provideAddress}">
                                </ng-template>
                                <div
                                    *ngIf="isEditing() && profileForm.get('primaryAddress.postalCode')?.invalid &&
                                         (profileForm.get('primaryAddress.postalCode')?.touched || profileForm.get('primaryAddress.postalCode')?.dirty)">
                                    <ng-container
                                        *ngIf="profileForm.get('primaryAddress.postalCode')?.errors as errors">
                                        <small class="text-danger" *ngIf="errors['required']">Postal code is
                                            required.</small>
                                        <small class="text-danger" *ngIf="!errors['required'] && errors['onlySpaces']">
                                            Postal code cannot contain only spaces.</small>
                                        <small class="text-danger" *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                            errors['leadingOrTrailingSpaces']">Postal code cannot start or end with a
                                            space.</small>
                                        <small class="text-danger" *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                            !errors['leadingOrTrailingSpaces'] && errors['maxlength']">
                                            Postal code cannot exceed 12 characters.</small>
                                        <small class="text-danger"
                                            *ngIf="!errors['required'] && !errors['onlySpaces'] &&
                                            !errors['leadingOrTrailingSpaces'] && !errors['maxlength'] && errors['pattern']">
                                            Postal code must be 3-12 characters, using only letters, numbers, spaces, or
                                            hyphens.</small>
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!-- Country -->
                            <div class="col-6 mb-3">
                                <label for="primaryAddress-country" class="form-label">Country <span
                                        *ngIf="provideAddress && isEditing()" class="text-danger">*</span></label>
                                <div *ngIf="!isEditing(); else editablePrimaryAddressCountry" class="form-value">
                                    {{ getCountryName(profileForm.get('primaryAddress.country')?.value) }}
                                </div>
                                <ng-template #editablePrimaryAddressCountry>
                                    <select id="primaryAddress-country" formControlName="country" class="form-control"
                                        [disabled]="!isEditing() || !provideAddress"
                                        [ngClass]="{'is-invalid': profileForm.get('primaryAddress.country')?.invalid &&
                                            (profileForm.get('primaryAddress.country')?.touched || profileForm.get('primaryAddress.country')?.dirty), 'form-control-disabled': !provideAddress}">
                                        <option value="" disabled selected>Select Country</option>
                                        <option *ngFor="let country of countriesOptions" [value]="country.code">{{
                                            country.name }}</option>
                                    </select>
                                </ng-template>

                                <div
                                    *ngIf="isEditing() && profileForm.get('primaryAddress.country')?.invalid &&
                                    (profileForm.get('primaryAddress.country')?.touched || profileForm.get('primaryAddress.country')?.dirty)">
                                    <small class="text-danger"
                                        *ngIf="profileForm.get('primaryAddress.country')?.errors?.['required']">
                                        Country is required.</small>
                                </div>
                            </div>

                            <!-- State -->
                            <div class="col-6 mb-3">
                                <label for="primaryAddress-state" class="form-label">State <span
                                        *ngIf="provideAddress && isEditing()" class="text-danger">*</span></label>

                                <div *ngIf="!isEditing(); else editablePrimaryAddressState" class="form-value">
                                    {{ profileForm.get('primaryAddress.state')?.value || '-' }}
                                </div>
                                <ng-template #editablePrimaryAddressState>
                                    <select id="primaryAddress-state" formControlName="state" class="form-control"
                                        [disabled]="!isEditing() || !provideAddress"
                                        [ngClass]="{'is-invalid': profileForm.get('primaryAddress.state')?.invalid &&
                                            (profileForm.get('primaryAddress.state')?.touched || profileForm.get('primaryAddress.state')?.dirty), 'form-control-disabled': !provideAddress}">
                                        <option value="" disabled selected>Select State</option>
                                        <option *ngFor="let state of statesOptions" [value]="state">{{ state }}</option>
                                    </select>
                                </ng-template>

                                <div
                                    *ngIf="isEditing() && profileForm.get('primaryAddress.state')?.invalid &&
                                        (profileForm.get('primaryAddress.state')?.touched || profileForm.get('primaryAddress.state')?.dirty)">
                                    <small class="text-danger"
                                        *ngIf="profileForm.get('primaryAddress.state')?.errors?.['required']">
                                        State is required.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Audio auto-navigation (saved immediately in local storage) -->
            <div class="row mb-3">
                <div class="col-md-12 audio-nav-toggle">
                    <mat-slide-toggle class="custom-toggle" labelPosition="before" [ngModel]="autoNavigateOnAudio"
                        [ngModelOptions]="{standalone: true}" (change)="onAutoNavigateOnAudioToggle($event.checked)">
                        <span class="audio-nav-title">Auto-turn pages</span>
                        <small class="audio-nav-description">Automatically flip to the next page when audio finishes
                            playing</small>
                    </mat-slide-toggle>
                </div>
            </div>

            <div class="row mb-3">
                <div class="subscribe-newsletter-checkbox">
                    <input type="checkbox" formControlName="IsMarketingOptedIn" id="IsMarketingOptedIn"
                        class="form-check-input" />
                    <label for="IsMarketingOptedIn">
                        <span>
                            <span>
                                I agree to receive product updates, feature announcements, and occasional promotional
                                offers.
                            </span>
                            <br />
                            <span> Unsubscribe anytime.</span>
                        </span>
                    </label>
                </div>
            </div>
            <div class="row action-row" *ngIf="isEditing()">
                <div class="d-flex justify-content-end">
                    <!-- Save Button -->
                    <button type="submit" class="btn btn-primary save-btn"
                        [disabled]="(!isFormChanged && !isFileUploaded) || profileForm.invalid || dobInput?.nativeElement?.validity?.badInput">
                        <i class="bi bi-floppy" style="margin-right: 10px;"></i>Save
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>